/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListConversationsQueryResponse, ListConversationsPathParams, ListConversationsQueryParams, ListConversations401, ListConversations500 } from "../../types/chatController/ListConversations.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";
import { listConversations } from "../../client/chatController/listConversations.ts";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export const listConversationsSuspenseQueryKey = (organizationId: ListConversationsPathParams["organizationId"] | undefined, params?: ListConversationsQueryParams) => [{ url: '/api/organizations/:organizationId/chat/conversations', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListConversationsSuspenseQueryKey = ReturnType<typeof listConversationsSuspenseQueryKey>

export function listConversationsSuspenseQueryOptions(organizationId: ListConversationsPathParams["organizationId"], params?: ListConversationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listConversationsSuspenseQueryKey(organizationId, params)
        return queryOptions<ListConversationsQueryResponse, ResponseErrorConfig<ListConversations401 | ListConversations500>, ListConversationsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return listConversations(organizationId, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List AI chat conversations
 * {@link /api/organizations/:organizationId/chat/conversations}
 */
export function useListConversationsSuspense<TData = ListConversationsQueryResponse, TQueryKey extends QueryKey = ListConversationsSuspenseQueryKey>(organizationId: ListConversationsPathParams["organizationId"], params?: ListConversationsQueryParams, options: 
{
  query?: Partial<UseSuspenseQueryOptions<ListConversationsQueryResponse, ResponseErrorConfig<ListConversations401 | ListConversations500>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listConversationsSuspenseQueryKey(organizationId, params)
         

         const query = useSuspenseQuery({
          ...listConversationsSuspenseQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<ListConversations401 | ListConversations500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}